import * as angular from 'angular';

import { ComponentDefinition, StateDto } from '../../../models';
import { IStateService } from '../../../services';

class StateTileController implements angular.IComponentController {
    readonly draggable: boolean = true;
    readonly state: StateDto;
    readonly withComment: boolean = true;

    static $inject = ['stateService'];

    constructor(private _stateService: IStateService) {
    }

    getUrlIcon(icon: string): string {
        return this._stateService.getIcon(icon);
    }
}

export const wtStateTile: ComponentDefinition = {
    componentId: 'wtStateTile',
    controller: StateTileController,
    template: require('./stateTile.component.html'),
    controllerAs: 'vm',
    bindings: {
        draggable: '<?',
        state: '<',
        withComment: '<?'
    }
};
